/**
 * Renders a label string where the text before parentheses is bold.
 * Supports single-line and multi-line (newline-separated) strings.
 * Example 1: "Chuẩn (Standard)" → <strong>Chuẩn </strong>(Standard)
 * Example 2: "- Cách thức gấp toa: 1 lần.\n- Kích thước toa gấp: (300 x 165)+/- 3mm"
 *          → "- Cách thức gấp toa: 1 lần." (as-is)
 *             "- Kích thước toa gấp: (300 x 165)+/- 3mm"

 */
export function RenderLabelWithoutBoldParentheses(
  label: string,
  otp?: { breakLine?: boolean } | undefined,
) {
  const lines = label.split("\n");

  const renderedLines = lines.map((line, index) => {
    const parenIndex = line.indexOf("(");
    // the label have to has ")" at the end of line, if not, we will not render it in bold
    const hasClosingParenAtEnd = line.endsWith(")") || line.endsWith(").");
    if (parenIndex === -1 || !hasClosingParenAtEnd) {
      return <span key={index}>{line}</span>;
    }

    const before = line.slice(0, parenIndex);
    const rest = line.slice(parenIndex);

    return (
      <span key={index}>
        <strong>{before}</strong>
        {otp?.breakLine ? <br /> : null}
        {rest}
      </span>
    );
  });

  return (
    <>
      {renderedLines.map((el, i) => (
        <span key={i}>
          {el}
          {i < renderedLines.length - 1 && <br />}
        </span>
      ))}
    </>
  );
}
